import type { Query, QueryClient, QueryKey, QueryOptions } from '@tanstack/react-query';

type QueryIdentity = Pick<QueryOptions, 'queryHash' | 'queryKeyHashFn'> & {
  readonly queryKey: QueryKey;
};

/** Indexed hits avoid session-sized scans; misses retain query-local hash compatibility. */
export function getCachedQuery(
  queryClient: QueryClient,
  options: QueryIdentity,
): Query | undefined {
  const { queryHash } = queryClient.defaultQueryOptions(options);
  const cache = queryClient.getQueryCache();
  // A key-only caller cannot reconstruct a query-local hash override, or defaults
  // that changed after insertion. Keep TanStack's exact match for those misses.
  return cache.get(queryHash) ?? cache.find({ queryKey: options.queryKey, exact: true });
}
